/**
 * Constants for the annotation editor
 */

/**
 * Konva group container names
 */
export const KONVA_GROUPS = {
  BOX_ANNOTATION: "box-annotation",
  POINT_ANNOTATION: "point-annotation",
} as const;

/**
 * Konva shape element names
 */
export const KONVA_SHAPES = {
  BOX_RECT: "box-rect",
  POINT_MARKER: "point-marker",
  BOX_LABEL: "box-label",
  POINT_LABEL: "point-label",
  IMAGE: "image",
} as const;

/**
 * Konva layer names
 */
export const KONVA_LAYERS = {
  IMAGE: "image-layer",
  ANNOTATIONS: "annotations",
  DRAWING: "drawing",
} as const;
